import { render } from "./MenuItem.vue?vue&type=template&id=57754c0a&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=57754c0a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57754c0a"],['__file',"src/vab/components/VabMenu/components/MenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57754c0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57754c0a', __exports__)) {
    console.log('reload')
    api.reload('57754c0a', __exports__)
  }
  
  module.hot.accept("./MenuItem.vue?vue&type=template&id=57754c0a&scoped=true", () => {
    console.log('re-render')
    api.rerender('57754c0a', render)
  })

}


export default __exports__